var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bo_nav_headline" }, [
    _c("h1", [
      _vm._v(
        _vm._s(
          (_vm.currentBoNavigation && _vm.currentBoNavigation.name) || _vm.title
        )
      )
    ]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(
        _vm._s(
          _vm.currentBoNavigation &&
            (_vm.currentBoNavigation.description ||
              _vm.currentBoNavigation.internaldescription)
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39f0dd94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f0dd94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/SportsBreadcrumb.vue
// module id = null
// module chunks = 